import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { isFullArray } from '@shared/lib/array'
import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface UploadCvReturn {
  mode: ComputedRef<InputMode>
  cv: ComputedRef<File | File[] | null>
  setDeleteDraftFile: () => void
  setDroppedCv: (acceptFiles: File[] | File | null) => void
}

export const useUploadCv = (): UploadCvReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const mode = computed(() => getMode(tutorApplicationStore.showErrors && !tutorApplicationStore.form.cv))
  const cv = computed(() => tutorApplicationStore.form.cv)

  const setDroppedCv = (acceptFiles: File[] | File | null): void => {
    if (!isFullArray(acceptFiles)) {
      tutorApplicationStore.setField('cv', acceptFiles)
    }
  }

  const setDeleteDraftFile = (): void => {
    tutorApplicationStore.setField('cv', null)
  }
  
  return {
    mode,
    cv,
    setDeleteDraftFile,
    setDroppedCv,
  }
}
